import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

import { auth } from "./auth";
import { app } from "./app/app";
import { profile } from "./app/profile";
import { record } from "./app/record";

import { client } from "./client/client";
import { patient } from "./patient/patient";
import { examination } from "./patient/examination";
import { file } from "./patient/file";
import { photo } from "./patient/photo";
import { calendar } from "./calendar";
import { document } from "./document";
import { invoice } from "./invoice";

export default new Vuex.Store({
    modules: {
        auth,
        app,
        profile,
        record,
        client,
        patient,
        examination,
        file,
        photo,
        calendar,
        document,
        invoice,
    },
});
